<template>
  <fragment>
    <common-header>
      <h2 class="page-tit m-t-30" v-if="step<2 && isInitial && copy">기존강좌 복사 등록 중</h2>
      <h2 class="page-tit m-t-30" v-else-if="step<2 && isInitial && !copy">강좌 {{modify?'수정':'등록'}}</h2>
      <h2 class="page-tit half-width" v-else>
        <div class="img-add m-r-10">
          <input id="img" type="file" />
          <label for="img">
            <img
              :src="classData.lecIcon?'/download/'+classData.lecIcon:'http://placehold.it/80x80'"
              alt
            />
          </label>
        </div>
        <small class="text-white m-t-15">
          <!--<span class="label" style="background-color: hotpink;">온라인</span>-->
          {{classData.categoryParent_?classData.categoryParent_.name:""}}
          {{classData.categoryChild_?' > '+classData.categoryChild_.name:""}}
        </small>
        {{classData.lecName}}
        <button
          class="btn-sm bg-blue round text-white v-top"
          type="button"
          @click="step=0"
        >수정</button>
      </h2>
    </common-header>

    <section class="container">
      <nav class="side-nav" v-if="(!modify && step<2 && isInitial)">&nbsp;</nav>
      <nav class="side-nav" v-else>
        <ul class="side-nav-menu selected">
          <li :class="{on:stepCompleted0,active:stepCompleted0}">
            <a @click="step=0">기본설정</a>
          </li>
          <!-- <li :class="{on:stepCompleted1,active:hasDefault1}">
            <a @click="step=1">강의실 설정</a>
          </li> -->
          <li :class="{on:stepCompleted2,active:stepCompleted2}">
            <a @click="step=2">강좌 목표 및 강좌 내용</a>
          </li>
          <li :class="{on:stepCompleted3,active:stepCompleted3}">
            <a @click="step=3">교육대상</a>
          </li>
          <li :class="{on:stepCompleted4,active:stepCompleted4}">
            <a @click="step=4">담당자</a>
          </li>
          <!--
					<li :class="{on:stepCompleted5,active:hasDefault5}">
						<a @click="step=5">수료기준/수료안내</a>
					</li>
          -->
          <li :class="{on:stepCompleted6,active:stepCompleted6}">
            <a @click="step=6">{{applFormType.link && applFormType.name || "신청양식 설정"}}</a>
          </li>
          <li :class="{on:stepCompleted7,active:stepCompleted7}">
            <a @click="step=7">신청및교육일정/정원</a>
          </li>
          <li :class="{on:stepCompleted8,active:stepCompleted8}">
            <a @click="step=8">수업계획표</a>
          </li>
        </ul>
      </nav>

      <div class="container-fiuld clearfix">
        <SubviewClassRegisterStep_0
          v-if="step==0"
          @nextStep="nextStep"
          @alert="openAlert"
          @confirm="openConfirm"
          @closeConfirm="modals.ModalConfirm.show=false"
          @setDefault="setDefault"
          :copy="copy"
          :modify="modify"
          :key="'class-register-step-0-'+hash(classData)"
          :default="defaultData"
          :classData="classData"
          :categories="categories"
        ></SubviewClassRegisterStep_0>
        <SubviewClassRegisterStep_1
          v-if="step==1"
          @nextStep="nextStep"
          @alert="openAlert"
          @confirm="openConfirm"
          @closeConfirm="modals.ModalConfirm.show=false"
          :key="'class-register-step-1-'+hash(classData)"
          :default="defaultData"
          :classData="classData"
        ></SubviewClassRegisterStep_1>
        <SubviewClassRegisterStep_2
          v-if="step==2"
          @nextStep="nextStep"
          @skipStep="skipStep"
          @alert="openAlert"
          @confirm="openConfirm"
          @closeConfirm="modals.ModalConfirm.show=false"
          :key="'class-register-step-2-'+hash(classData)"
          :default="defaultData"
          :classData="classData"
        ></SubviewClassRegisterStep_2>
        <SubviewClassRegisterStep_3
          v-if="step==3"
          @nextStep="nextStep"
          @skipStep="skipStep"
          @alert="openAlert"
          @confirm="openConfirm"
          @closeConfirm="modals.ModalConfirm.show=false"
          :key="'class-register-step-3-'+hash(classData)"
          :default="defaultData"
          :classData="classData"
          :jobs="jobs"
        ></SubviewClassRegisterStep_3>
        <SubviewClassRegisterStep_4
          v-if="step==4"
          @nextStep="nextStep"
          @skipStep="skipStep"
          @alert="openAlert"
          @confirm="openConfirm"
          @closeConfirm="modals.ModalConfirm.show=false"
          :key="'class-register-step-4-'+hash(classData)"
          :default="defaultData"
          :classData="classData"
          :admins="admins"
          :teachers="teachers"
        ></SubviewClassRegisterStep_4>
        <!--
				<SubviewClassRegisterStep_5 v-if="step==5" @nextStep="nextStep" @skipStep="skipStep" @alert="openAlert" @confirm="openConfirm" @closeConfirm="modals.ModalConfirm.show=false" :key="'class-register-step-5-'+hash(classData)" :classData="classData"></SubviewClassRegisterStep_5>
        -->
        <SubviewClassRegisterStep_6
          v-if="step==6"
          @nextStep="nextStep"
          @skipStep="skipStep"
          @alert="openAlert"
          @confirm="openConfirm"
          @closeConfirm="modals.ModalConfirm.show=false"
          @preview="showPreview"
          :key="'class-register-step-6-'+hash(classData)"
          :default="defaultData"
          :classData="classData"
        ></SubviewClassRegisterStep_6>
        <SubviewClassRegisterStep_7
          v-if="step==7"
          @nextStep="nextStep"
          @skipStep="skipStep"
          @alert="openAlert"
          @confirm="openConfirm"
          @closeConfirm="modals.ModalConfirm.show=false"
          :key="'class-register-step-7-'+hash(classData)"
          :default="defaultData"
          :classData="classData"
        ></SubviewClassRegisterStep_7>
        <SubviewClassRegisterStep_8
          v-if="step==8"
          @nextStep="nextStep"
          @skipStep="skipStep"
          @alert="openAlert"
          @confirm="openConfirm"
          @closeConfirm="modals.ModalConfirm.show=false"
          :key="'class-register-step-8-'+hash(classData)"
          :default="defaultData"
          :classData="classData"
        ></SubviewClassRegisterStep_8>
      </div>
    </section>

    <modal-alert
      :config="modals.ModalAlert"
      :key="'modal-alert-'+hash(modals.ModalAlert)"
      @close="modals.ModalAlert.show=false"
    ></modal-alert>
    <modal-confirm
      :config="modals.ModalConfirm"
      :key="'modal-confirm-'+hash(modals.ModalConfirm)"
      @no="modals.ModalConfirm.show=false"
    ></modal-confirm>

    <modal-apply-manual-type-online
			:config="modals.ModalApplyManualTypeOnline"
			@close="modals.ModalApplyManualTypeOnline.show=false;"
			:key="'subview-class-register-preview-'+hash(modals.ModalApplyManualTypeOnline)"
			@done="modals.ModalApplyManualTypeOnline.show=false;"
		></modal-apply-manual-type-online>

		<modal-apply-manual-type-income
			:config="modals.ModalApplyManualTypeIncome"
			@close="modals.ModalApplyManualTypeIncome.show=false;"
			:key="'subview-class-register-preview-'+hash(modals.ModalApplyManualTypeIncome)"
			@done="modals.ModalApplyManualTypeIncome.show=false;"
		></modal-apply-manual-type-income>

		<modal-apply-manual-type-outgo
			:config="modals.ModalApplyManualTypeOutgo"
			@close="modals.ModalApplyManualTypeOutgo.show=false;"
			:key="'subview-class-register-preview-'+hash(modals.ModalApplyManualTypeOutgo)"
			@done="modals.ModalApplyManualTypeOutgo.show=false;"
		></modal-apply-manual-type-outgo>

		<modal-apply-manual-type-dream
			:config="modals.ModalApplyManualTypeDream"
			@close="modals.ModalApplyManualTypeDream.show=false;"
			:key="'subview-class-register-preview-'+hash(modals.ModalApplyManualTypeDream)"
			@done="modals.ModalApplyManualTypeDream.show=false;"
		></modal-apply-manual-type-dream>

		<modal-apply-manual-type-ssok
			:config="modals.ModalApplyManualTypeSsok"
			@close="modals.ModalApplyManualTypeSsok.show=false;"
			:key="'subview-class-register-preview-'+hash(modals.ModalApplyManualTypeSsok)"
			@done="modals.ModalApplyManualTypeSsok.show=false;"
    ></modal-apply-manual-type-ssok>

    <modal-apply-manual-type-teacher
			:config="modals.ModalApplyManualTypeTeacher"
			@close="modals.ModalApplyManualTypeTeacher.show=false;"
			:key="'subview-class-register-preview-'+hash(modals.ModalApplyManualTypeTeacher)"
			@done="modals.ModalApplyManualTypeTeacher.show=false;"
		></modal-apply-manual-type-teacher>
  </fragment>
</template>

<script>
import fnGetJobData from "../mixins/fnGetJobData.js";
import CommonHeader from "../components/CommonHeader.vue";
import server from "../statics/server.js";
import axios from "axios";

import ModalAlert from "../modals/ModalAlert.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";

import SubviewClassRegisterStep_0 from "./subviews/SubviewClassRegisterStep_0.vue";
import SubviewClassRegisterStep_1 from "./subviews/SubviewClassRegisterStep_1.vue";
import SubviewClassRegisterStep_2 from "./subviews/SubviewClassRegisterStep_2.vue";
import SubviewClassRegisterStep_3 from "./subviews/SubviewClassRegisterStep_3.vue";
import SubviewClassRegisterStep_4 from "./subviews/SubviewClassRegisterStep_4.vue";
//import SubviewClassRegisterStep_5 from './subviews/SubviewClassRegisterStep_5.vue' // 수료기준/수료안내는 커리큘럼 설정을 따른다.
import SubviewClassRegisterStep_6 from "./subviews/SubviewClassRegisterStep_6.vue";
import SubviewClassRegisterStep_7 from "./subviews/SubviewClassRegisterStep_7.vue";
import SubviewClassRegisterStep_8 from "./subviews/SubviewClassRegisterStep_8.vue";

import ModalApplyManualTypeOnline from "../modals/ModalApplyManualTypeOnline.vue";
import ModalApplyManualTypeIncome from "../modals/ModalApplyManualTypeIncome.vue";
import ModalApplyManualTypeOutgo from "../modals/ModalApplyManualTypeOutgo.vue";
import ModalApplyManualTypeDream from "../modals/ModalApplyManualTypeDream.vue";
import ModalApplyManualTypeSsok from "../modals/ModalApplyManualTypeSsok.vue";
import ModalApplyManualTypeTeacher from "../modals/ModalApplyManualTypeTeacher.vue";

export default {
  name: "VuewClassRegister",
  mixins: [fnGetJobData],

  components: {
    CommonHeader,
    ModalAlert,
    ModalConfirm,
    SubviewClassRegisterStep_0,
    SubviewClassRegisterStep_1,
    SubviewClassRegisterStep_2,
    SubviewClassRegisterStep_3,
    SubviewClassRegisterStep_4,
    //SubviewClassRegisterStep_5, // 수료기준/수료안내는 커리큘럼 설정을 따른다.
    SubviewClassRegisterStep_6,
    SubviewClassRegisterStep_7,
    SubviewClassRegisterStep_8,
    ModalApplyManualTypeOnline,
    ModalApplyManualTypeIncome,
    ModalApplyManualTypeOutgo,
    ModalApplyManualTypeDream,
    ModalApplyManualTypeSsok,
    ModalApplyManualTypeTeacher
  },
  mounted: async function() {
    // 카테고리 목록 (categories) 조회
    await axios
      .post(server.addr() + server.api.CATEGORY, {
        parentsId: 0
      })
      .then(response => {
        this.categories = response.data.list;
        this.categories.forEach(el => {
          axios
            .post(server.addr() + server.api.CATEGORY, {
              parentsId: el.categoryId
            })
            .then(response => {
              el.childs = response.data.list;
              el.childs.forEach(el => {
                axios
                  .post(server.addr() + server.api.CATEGORY, {
                    parentsId: el.categoryId
                  })
                  .then(response => {
                    el.childs = response.data.list;
                  })
                  .catch(error => {
                    error;
                    this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
                    this.modals.ModalAlert.show = true;
                  });
              });
            })
            .catch(error => {
              error;
              this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
              this.modals.ModalAlert.show = true;
            });
        });
      })
      .catch(error => {
        error;
        this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
        this.modals.ModalAlert.show = true;
      });
    // 담당자 목록 (admins) 조회
    await axios
      .post(server.addr() + server.api.MBER, {
        filterList: [],
        keyword: "",
        orderBy: "MBER_ID",
        adminEnable: 1
      })
      .then(response => {
        this.admins = response.data.list;
      })
      .catch(error => {
        error;
        this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
        this.modals.ModalAlert.show = true;
      });
    // 강사 목록 (teachers) 조회
    await axios
      .post(server.addr() + server.api.MBER, {
        instEnable: 1
      })
      .then(response => {
        this.teachers = response.data.list;
      })
      .catch(error => {
        error;
        this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
        this.modals.ModalAlert.show = true;
      });
    // 화면 이동
    this.setStep();
  },
  data: () => {
    return {
      modals: {
        ModalAlert: ModalAlert.default(),
        ModalConfirm: ModalConfirm.default(),
        ModalApplyManualTypeOnline: ModalApplyManualTypeOnline.default(),
				ModalApplyManualTypeIncome: ModalApplyManualTypeIncome.default(),
				ModalApplyManualTypeOutgo: ModalApplyManualTypeOutgo.default(),
				ModalApplyManualTypeDream: ModalApplyManualTypeDream.default(),
        ModalApplyManualTypeSsok: ModalApplyManualTypeSsok.default(),
        ModalApplyManualTypeTeacher: ModalApplyManualTypeTeacher.default()
      },
      isInitial: true,
      step: 0,
      stepCompleted: [],
      copy: false,
      modify: false,
      categories: [], // 강의카테고리 목록
      admins: [], // 담당자 목록
      teachers: [], // 강사 목록
      defaultData: null, // 강좌개설 초기값
      classData: {
        lecId: 0, // 강의ID
        templStreEnable: 1, // 임시저장여부 (1이면 임시저장)
        categoryId: 0, // 카테고리 목록중 seq
        categoryParent_: null, // 선택된 1차 카테고리
        categoryChild_: null, // 선택된 2차 카테고리
        lecName: "", // 강의명
        lecIcon: "", // 강의아이콘 파일

        classroomOpt: "", // 강의실옵션 (JSON 문자열)
        goal: "", // 강의목표
        content: "", // 강의내용

        lesTargetWork: "", // 교육대상 (직업코드 문자열 CSV)

        lesTargetType: "", // 교육대상 분류 (개인/단체)
        lesTargetDetail: "", // 교육대상 상세
        inCharge: "", // 관리담당자 (관리자 회원목록중 seq)
        instAllotType: "", // 강사 분류 (강사없음/강사지정/신청후배정)
        eduList: [], // 강사목록

        finishEnable: 0, // 수료있음/없음
        autoFinishEnable: 0, // 자동수료 여부

        autoFinishCondi: [
          // { name: "전체진도율", enabled: false, value: 0 },
          // { name: "차시별 재생시간", enabled: false, value: 0 },
          // { name: "성적", enabled: false, value: 0 },
          // { name: "출석", enabled: false, value: 0 },
          // { name: "과제", enabled: false, value: 0 }
        ], // 수료기준 **JSON.stringify해서 보낼 것**

        finishInfo: "", // 수료안내

        applForm: "", // 수강 신청양식 목록중 seq
        certForm: "", // 수료증양식 목록중 seq

        applStartDate: null,
        applEndDate: null,
        applOpt: [
          { name: "자동승인", enabled: false },
          { name: "교육일자 기준", enabled: false, value: 0 },
          {
            name: "교육월 기준",
            enabled: false,
            fromMonth: "지난달",
            fromDate: 1,
            toMonth: "지난달",
            toDate: 31
          }
        ],
        autoAcceptEnable: 0, // 자동승인여부
        eduPeriodType: "", // "교육일 지정" or "수강생 신청" or "일정 선택"
        eduDuration: 0,
        eduDay: 0,
        lecEduDateList: [
          {
            eduStartDate: null,
            eduEndDate: null,
            eduStartTime: null,
            eduEndTime: null,
            eduDuration: "",
            eduFixedNum: 0
          }
        ],
        applGuide: "", // 신청안내
        eduGuide: "", // 교육 안내

        lesPlanFile: "", // 강의계획서 파일
        lesPlanNotExists: false // 강의계획서가 없는지 여부
      },
      applFormType: server.applFormType || {}
    };
  },
  watch: {},
  methods: {
    showPreview: function(formName) {
      if(formName=="온라인") {
				this.modals.ModalApplyManualTypeOnline.show = true;
			} else if(formName=="원내") {
				this.modals.ModalApplyManualTypeIncome.show = true;
			} else if(formName=="찾아가는 국어문화학교") {
				this.modals.ModalApplyManualTypeOutgo.show = true;
			} else if(formName=="우리말 꿈터") {
				this.modals.ModalApplyManualTypeDream.show = true;
			} else if(formName=="쏙!쏙! 국어교실") {
				this.modals.ModalApplyManualTypeSsok.show = true;
			} else if(formName=="교사직무연수") {
        this.modals.ModalApplyManualTypeTeacher.show = true;
      }
    },
    setDefault: function(lec) {
      let obj = JSON.parse(JSON.stringify(lec));
      obj.lesPlanFile = obj.lesPlanFile ? obj.lesPlanFile.atchFileId : null;
      obj.lecIcon = obj.lecIcon ? obj.lecIcon.atchFileId : null;
      obj.inCharge = obj.inCharge ? obj.inCharge.mberId : null;
      obj.categoryParent_ = this.categories.find(
        c => c.categoryId == obj.categoryId
      );
      if (!obj.categoryParent_) {
        obj.categoryParent_ = this.categories.find(
          c1 =>
            c1.categoryId == obj.categoryId ||
            c1.childs.find(c2 => c2.categoryId == obj.categoryId)
        );
        obj.categoryChild_ = obj.categoryParent_.childs.find(
          c1 => c1.categoryId == obj.categoryId
        );
      } else {
        obj.categoryChild_ = null;
      }
      if (!this.modify) {
        obj.lecId = "";
        obj.templStreEnable = 1;
      }
      this.classData = obj;
    },
    setStep: function() {
      const { step, copy, modify, origin } = this.$route.query;
      this.step = parseInt(step) ? parseInt(step) : 0;
      this.copy = copy === "true";
      this.modify = modify === "true";
      if (origin) {
        axios.post(`${server.addr()}/lec/${origin}`, {}).then(response => {
          this.setDefault(response.data.return);
          if (!this.classData.inCharge) this.classData.inCharge = "";
          if (!this.classData.autoAcceptEnable)
            this.classData.autoAcceptEnable = false;
          if (this.modify) {
            [0, 1, 2, 3, 4, 5, 6, 7, 8].forEach(n =>
              this.stepCompleted.push(n)
            );
          }
        });
      }
    },
    nextStep: function(classData) {
      // 스텝에서 넘어온 데이터를 저장하고
      if (classData) {
        /*
        // eslint-disable-next-line
        console.log("여기서 이게 뭔지 확인 (원래 갖고있던 객체)", this.classData);
        // eslint-disable-next-line
        console.log("여기서 이게 뭔지 확인 (서브뷰에서 넘어온 객체)", classData);
        // eslint-disable-next-line
        console.log(
          "여기서 이게 뭔지 확인 (서브뷰에서 넘어온 키 목록)",
          Object.keys(classData)
        );
          */
          for (let i = 0; i < Object.keys(classData).length; i += 1) {

          /*
          // eslint-disable-next-line
          console.log(
            "여기서 이게 뭔지 확인 ("+i+"번째) 키:"+Object.keys(classData)[i],
            "서브뷰에서 넘어온 값:"+classData[Object.keys(classData)[i]],
            "원래 들어있던 값:"+this.classData[Object.keys(classData)[i]]
          );
          */
          this.classData[Object.keys(classData)[i]] = JSON.parse(
            JSON.stringify(classData[Object.keys(classData)[i]])
          );

          /*
          // eslint-disable-next-line
          console.log("여기까지 확인됨")
          */
        }
      }
      // 수정모드가 아닌 경우, 0스텝에서 1스텝으로 넘어갈때, 카테고리가 정해진 경우 템플릿이 존재하면 읽어오고, PUT 요청으로 레코드 생성
      if (this.step == 0 && !this.modify) {
        let selectedCategory = 0;
        if (this.classData.categoryParent_)
          selectedCategory = this.classData.categoryParent_.categoryId;
        if (this.classData.categoryChild_)
          selectedCategory = this.classData.categoryChild_.categoryId;
        // 선택된 카테고리에 템플릿이 존재하는지 확인
        axios
          .post(server.addr() + server.api.LECTURE_TEMPLATE, {
            categoryId: selectedCategory
          })
          .then(response => {
            if (response.status == 200 && response.data.return) {
              this.defaultData = response.data.return;
              // 강좌를 복사중인 경우에는 기본값을 채워넣지 않음
              if (!this.copy && this.defaultData) {
                this.classData = {
                  ...response.data.return,
                  autoAcceptEnable: this.defaultData.autoAcceptEnable?this.defaultData.autoAcceptEnable:0,
                  applOpt: JSON.parse(this.defaultData.applOpt),
                  eduList: this.defaultData.eduTemplList,
                  lecEduDateList: this.defaultData.lecEduDateTemplList,
                  lecName: this.classData.lecName,
                  categoryParent_: JSON.parse(JSON.stringify(this.classData.categoryParent_)),
                  categoryChild_: JSON.parse(JSON.stringify(this.classData.categoryChild_)),
                  categoryId: selectedCategory
                };
              }
            }
            // LEC레코드 생성
            axios
              .put(server.addr() + server.api.LECTURE, [
                {
                  ...this.classData,
                  inCharge:
                    typeof this.classData.inCharge == "string"
                      ? this.classData.inCharge
                      : this.classData.inCharge.mberId,
                  applOpt:
                    typeof this.classData.applOpt == "string"
                      ? this.classData.applOpt
                      : JSON.stringify(this.classData.applOpt),
                  autoFinishCondi: typeof this.classData.autoFinishCondi == "object"
                      ? JSON.stringify(this.classData.autoFinishCondi)
                      : this.classData.autoFinishCondi,
                }
              ])
              .then(response => {
                if (
                  response.status == 200 &&
                  response.data &&
                  response.data.list
                ) {
                  // 지금 입력한 강의ID 설정
                  this.classData.lecId = response.data.list[0].lecId;
                  // 스텝 이동 처리
                  this.stepCompleted.push(this.step);
                  // 1번 스탭 건너뛰기(직장맘)
                  this.stepCompleted.push(1);
                  this.step = this.step + 2;
                } else {
                  // eslint-disable-next-line
                  console.error(
                    "강의 추가하고 비정상응답",
                    response.status,
                    response.data
                  );
                }

                /*
                // eslint-disable-next-line
                console.log("강의 추가하고 지금 갖고 있는 객체는", this.classData)
                */
              })
              .catch(error => {
                error;
                this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
                this.modals.ModalAlert.show = true;
              });
          });
      }
      // 수정모드인 경우, 0스텝에서 1스텝으로 넘어갈때 PATCH 요청으로 레코드 갱신
      else if (this.step == 0 && this.modify) {
        axios
          .patch(`${server.addr()}${server.api.LECTURE}/${this.classData.lecId}`,
            {
              ...this.classData,
              lecEduDateList: this.classData.lecEduDateList
                ? this.classData.lecEduDateList.filter(e => e.eduStartDate)
                : [],
              lesPlanFile:
                this.classData.lesPlanFile && typeof this.classData.lesPlanFile === "object"
                  ? this.classData.lesPlanFile.atchFileId
                  : this.classData.lesPlanFile,
              inCharge:
                typeof this.classData.inCharge == "object"
                  ? this.classData.inCharge.mberId
                  : this.classData.inCharge,
              applOpt:
                typeof this.classData.applOpt == "object"
                  ? JSON.stringify(this.classData.applOpt)
                  : this.classData.applOpt,
              autoFinishCondi: typeof this.classData.autoFinishCondi == "object"
                  ? JSON.stringify(this.classData.autoFinishCondi)
                  : this.classData.autoFinishCondi,
            }
          )
          .then(response => {
            if (response.status == 200) {
              // 스텝 이동 처리
              this.stepCompleted.push(this.step);
              // 1번 스탭 건너뛰기(직장맘)
              this.stepCompleted.push(1);
              this.step = this.step + 2;
            } else {
              // eslint-disable-next-line
              console.error(
                "강의 갱신하고 비정상응답",
                response.status,
                response.data
              );
            }
          })
          .catch(error => {
            error;
            this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
            this.modals.ModalAlert.show = true;
          });
      }
      // 1스텝부터 8스텝까지 넘어갈때 PATCH 요청으로 레코드 업데이트 (단, step==5 화면은 건너뛰어야 함. 커리큘럼 화면으로 넘어갔으므로.)
      else if (this.step >= 1 && this.step <= 7) {
        // axios 요청 날린다.
        axios
          .patch(
            server.addr() + server.api.LECTURE + "/" + this.classData.lecId,
            {
              ...this.classData,
              lecEduDateList: this.classData.lecEduDateList
                ? this.classData.lecEduDateList.filter(e => e.eduStartDate)
                : [],
              lesPlanFile:
                this.classData.lesPlanFile && typeof this.classData.lesPlanFile === "object"
                  ? this.classData.lesPlanFile.atchFileId
                  : this.classData.lesPlanFile,
              inCharge:
                typeof this.classData.inCharge == "string"
                  ? this.classData.inCharge
                  : this.classData.inCharge.mberId,
              applOpt:
                typeof this.classData.applOpt == "string"
                  ? this.classData.applOpt
                  : JSON.stringify(this.classData.applOpt),
              autoFinishCondi: typeof this.classData.autoFinishCondi == "object"
                  ? JSON.stringify(this.classData.autoFinishCondi)
                  : this.classData.autoFinishCondi,
            }
          )
          .then(response => {
            if (response.status == 200) {
              // 응답이 정상이면 스텝 이동 처리
              this.stepCompleted.push(this.step);
              this.step = this.step + 1;
              if (this.step == 2) this.isInitial = false;
              // 5번은 건너뛴다. 커리큘럼 화면으로 넘어갔으므로.
              if (this.step == 5) this.step = 6;
            } else {
              // eslint-disable-next-line
              console.error(
                "강의 업데이트하고 비정상응답",
                response.status,
                response.data
              );
            }
          })
          .catch(error => {
            this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
            this.modals.ModalAlert.show = true;
            // eslint-disable-next-line
            console.error("ERROR on step " + this.step, error);
          });
      }
      // 8스텝까지 작성을 마친 경우, 강의를 확정할 것인지 임시저장 상태로 둘 것인지 확인하는 컨펌창 필요
      // 확정지을때에는 임시저장여부를 0으로 표시해서 확정시키고 PATCH 요청으로 레코드 업데이트
      else if (this.step == 8) {
        // 강의계획서가 있거나, 또는, 강의계획서가 없다고 표시된 경우, 8스텝이 완료된것으로 본다.
        if (this.classData.lesPlanFile || this.classData.lesPlanNotExists)
          this.stepCompleted.push(8);
        // 모든 입력항목이 정상인지 확인한다.
        // console.log(this.stepCompleted);
        for (let s = 0; s <= 8; s += 1) {
          if (s == 5) continue; // 5번스탭은 입력을 확인하지 않는다. 커리큘럼 화면에서 할 것이므로.
          if (this.stepCompleted.indexOf(s) == -1) {
            this.modals.ModalAlert.msg =
              "입력되지 않은 항목이 있으므로<br>강좌를 개설할 수 없습니다.";
            this.modals.ModalAlert.show = true;
            return;
          }
        }
        this.modals.ModalConfirm.msg =
          "모든 항목에 대한 입력이 완료되었습니다.<br>이대로 강좌를 개설합니까?";
        this.modals.ModalConfirm.btnYes.name = "강좌 개설";
        this.modals.ModalConfirm.btnYes.fn = () => {
          // 임시저장이 아님을 표시하고
          this.classData.templStreEnable = 0;
          // axios 요청 날린다.
          axios
            .patch(
              server.addr() + server.api.LECTURE + "/" + this.classData.lecId,
              {
                ...this.classData,
                lecEduDateList: this.classData.lecEduDateList
                  ? this.classData.lecEduDateList.filter(e => e.eduStartDate)
                  : [],
                lesPlanFile:
                  typeof this.classData.lesPlanFile == "object"
                    ? this.classData.lesPlanFile.atchFileId
                    : this.classData.lesPlanFile,
                inCharge:
                  typeof this.classData.inCharge == "string"
                    ? this.classData.inCharge
                    : this.classData.inCharge.mberId,
                applOpt:
                  typeof this.classData.applOpt == "string"
                    ? this.classData.applOpt
                    : JSON.stringify(this.classData.applOpt),
                autoFinishCondi: typeof this.classData.autoFinishCondi == "object"
                    ? JSON.stringify(this.classData.autoFinishCondi)
                    : this.classData.autoFinishCondi,
              }
            )
            .then(response => {
              if (response.status == 200) {
                // 응답이 정상이면 강의 목록 화면으로 이동
                this.$router.push("/classes");
              } else {
                // eslint-disable-next-line
                console.error(
                  "강의 확정하고 비정상응답",
                  response.status,
                  response.data
                );
              }
            })
            .catch(error => {
              error;
              this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
              this.modals.ModalAlert.show = true;
            });
        };
        this.modals.ModalConfirm.btnNo.name = "임시저장 상태로 두기";
        this.modals.ModalConfirm.btnNo.fn = () => {
          // 임시저장임을 표시하고
          this.classData.templStreEnable = 1;
          // axios 요청 날린다.
          axios
            .patch(
              server.addr() + server.api.LECTURE + "/" + this.classData.lecId,
              {
                ...this.classData,
                lecEduDateList: this.classData.lecEduDateList
                  ? this.classData.lecEduDateList.filter(e => e.eduStartDate)
                  : [],
                lesPlanFile:
                  typeof this.classData.lesPlanFile == "object"
                    ? this.classData.lesPlanFile.atchFileId
                    : this.classData.lesPlanFile,
                inCharge:
                  typeof this.classData.inCharge == "string"
                    ? this.classData.inCharge
                    : this.classData.inCharge.mberId,
                applOpt:
                  typeof this.classData.applOpt == "string"
                    ? this.classData.applOpt
                    : JSON.stringify(this.classData.applOpt),
                autoFinishCondi: typeof this.classData.autoFinishCondi == "object"
                    ? JSON.stringify(this.classData.autoFinishCondi)
                    : this.classData.autoFinishCondi,
              }
            )
            .then(response => {
              if (response.status == 200) {
                // 응답이 정상이면 강의 목록 화면으로 이동
                this.$router.push("/classes");
              } else {
                // eslint-disable-next-line
                console.error(
                  "강의 임시저장하고 비정상응답",
                  response.status,
                  response.data
                );
              }
            })
            .catch(error => {
              error;
              this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
              this.modals.ModalAlert.show = true;
            });
        };
        this.modals.ModalConfirm.show = true;
      }
    },
    skipStep: function() {
      // 스텝 이동
      if (this.step === 8) return;
      else if (this.step == 4) this.step = 6;
      else this.step = this.step + 1;
    },
    openAlert: function(msg) {
      this.modals.ModalAlert.msg = msg;
      this.modals.ModalAlert.show = true;
    },
    openConfirm: function(msg, fnYes, fnNo) {
      this.modals.ModalConfirm.msg = msg;
      this.modals.ModalConfirm.btnYes.fn = fnYes;
      this.modals.ModalConfirm.btnNo.fn = fnNo;
      this.modals.ModalConfirm.show = true;
    }
  },
  computed: {
    stepCompleted0: function() {
      return this.stepCompleted.indexOf(0) !== -1;
    },
    stepCompleted1: function() {
      return this.stepCompleted.indexOf(1) !== -1;
    },
    stepCompleted2: function() {
      return this.stepCompleted.indexOf(2) !== -1;
    },
    stepCompleted3: function() {
      return this.stepCompleted.indexOf(3) !== -1;
    },
    stepCompleted4: function() {
      return this.stepCompleted.indexOf(4) !== -1;
    },
    //stepCompleted5: function() { return this.stepCompleted.indexOf(5)!==-1 },
    stepCompleted6: function() {
      return this.stepCompleted.indexOf(6) !== -1;
    },
    stepCompleted7: function() {
      return this.stepCompleted.indexOf(7) !== -1;
    },
    stepCompleted8: function() {
      return this.stepCompleted.indexOf(8) !== -1;
    },

    hasDefault0: function() {
      return false;
    },
    hasDefault1: function() {
      return false;
    },
    hasDefault2: function() {
      return false;
    },
    hasDefault3: function() {
      return false;
    },
    hasDefault4: function() {
      return false;
    },
    //hasDefault5: function() { return false },
    hasDefault6: function() {
      return false;
    },
    hasDefault7: function() {
      return false;
    },
    hasDefault8: function() {
      return false;
    }
  }
};
</script>